<template>
    <v-container>
        <v-row>
            <v-col>
                <h1>Download corpus files as a zip</h1>
                <br><v-btn depressed large color="primary" :href="`${publicPath}data/all.zip`">
                    <v-icon left>mdi-download
                    </v-icon>
                    Download 
                </v-btn> <strong>all.zip</strong> 
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
export default {
    data() {
        return {
            publicPath: process.env.BASE_URL
        }
    }
}
</script>